import styled from 'styled-components';

const StyledBackground = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	background: #111314;
	opacity: 0;
	transition: opacity 0.3s ease;
`;

export { StyledBackground };
